import React, { Component } from 'react'
import axios from 'axios'



export default class Certificado extends Component {
  constructor(props){
    super(props);
    this.state = {
      img_url: null,
      pdf_url: null,
      cargando: true,
      error: false,
      status: -1,
      nombre: null,
      ci: null
    }

    this.other_data = {};

    this.requestCertificate = this.requestCertificate.bind(this);
    this.processResponse = this.processResponse.bind(this);
    this.showImage = this.showImage.bind(this);
    this.processError = this.processError.bind(this);
    this.requestCertificate();
  }

  requestCertificate(){
    // obtengo los datos
    let params = this.props.match.params;
    //axios.post("http://127.0.0.1/ceis/conn_bd.php", {
    axios.post("https://aulas.ideasparatunegocio.com.py/static/conn_bd.php", {
      peticion: "mostrar_certificado",
      datos: {
        idcurso: params.idcertificado,
        ci: params.ci
      }
    }).then(this.processResponse).catch(this.processError);
  }

  processResponse(response){
    console.log("response", response);
    let certificados = response.data.certificados;
    if(certificados.length === 0){
      this.setState({
        error: true,
        status: 404,
        cargando: false
      });
      return;
    }
    // se genera la imagen
    let cert = certificados[0];
    let formData = new FormData();
    formData.set('nombre', cert.nombre);
    formData.set('ci', cert.ci);
    formData.set('nombre_curso', cert.nombre_curso);
    formData.set('duracion', cert.duracion);
    formData.set('direccion', cert.direccion);
    formData.set('fecha', cert.fecha);
    formData.set('tipo_certificado', cert.tipo_certificado);
    formData.set('idcurso', this.props.match.params.idcertificado);
    formData.set('apikey', 'UQytA6jVVq');
    this.other_data['nombre'] = cert.nombre;
    this.other_data['malla'] = cert.malla;
    this.other_data['nombre_curso'] = cert.nombre_curso;
    this.other_data['ci'] = cert.ci;
    axios({
      method: 'post',
      url: 'https://server.tamaysistemas.com/certificados-ceis/json.php',
      data: formData,
      config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
    .then(this.showImage)
    .catch(this.processError);
  }

  showImage(response){
    this.setState({
      cargando: false,
      error: false,
      status: 200,
      img_url: response.data.file_url,
      pdf_url: response.data.pdf
    });
  }

  processError(response){
    this.setState({ error: true, status: 500, cargando: false });
  }

  renderCargando(){
    return (
      <div className="container">
        <div className="alert alert-info mt-5" role="alert">
          Cargando...
        </div>
      </div>
    );
  }

  renderError(){
    switch (this.state.status) {
      case 404:
        return (
          <div className="container">
            <div className="alert alert-warning mt-5" role="alert">
              Certificado no encontrado
            </div>
          </div>
        );
      case 500:
        return (
          <div className="container">
            <div className="alert alert-danger mt-5" role="alert">
              Error al comunicarse con los servidores
            </div>
          </div>
        );
      default:

    }
    return (
      <div className="container">
        <div className="alert alert-info mt-5" role="alert">
          Error al cargar la
        </div>
      </div>
    );
  }

  getMallaUrl(url){
    if(url!==undefined && url!==""){
      return (
        <a className="btn btn-secondary"
        href={`https://server.tamaysistemas.com/certificados-ceis/malla.php?file=${encodeURI(url)}`}
        target="_blank">
          Ver Malla
        </a>
      );
    } else {
      return "";
    }
  }

  render(){
    console.log("state", this.state);
    if(this.state.error === true){
      return this.renderError();
    }
    if(this.state.cargando === true){
      return this.renderCargando();
    }

    return (
      <div className="container">
        <div className="card mt-3">
            <div className="card-body text-left text-dark">
              <h4 className="mb-0">
                Centro de Formación y capacitación laboral CEIS
              </h4>
              <p className="card-subtitle text-muted">Certificado otorgado a {this.other_data.nombre} con C.I. {this.other_data.ci}</p>
              <span className="btn-group">
                {this.getMallaUrl(this.other_data.malla)}
                <a
                href={this.state.pdf_url}
                download={`Certificado ${this.other_data.nombre_curso} ${this.other_data.nombre}.png`}
                className="btn btn-secondary float-right">
                Descarga Aquí tu Certificado <i className="fa fa-download"/>
                </a>
              </span>
            </div>
            <img src={this.state.img_url} className="card-img-bottom" alt="certificado img"/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/certificado.js